module.exports = __webpack_public_path__ + "img/img.e25a4e7a.png";